import { logWrapper } from '../utils';

export default {
  listModel: [
    'runtimeConstant',
    '$filter',
    function (runtimeConstant, $filter) {
      function List(data) {
        this.id = data ? data.Id : 0;
        this.idCompany = data ? data.IdCompany : 0;
        this.name = data ? data.Name : '';
        this.items = data ? data.Items : '';
        this.itemsArray = data ? data.Items : [];
        this.selected = false;
      }

      function title() {
        return this.name;
      }

      function details() {
        return null;
      }

      function tags() {
        var tags = this.items;
        var size = tags.length;

        if (tags.length > 10) {
          tags = tags.slice(0, 10);
          tags.push(
            String.format($filter('translate')('MORE X ITEMS'), [size - 10])
          );
        }

        return tags;
      }

      function removeItem(item) {
        this.itemsArray.splice(this.itemsArray.indexOf(item), 1);
      }

      function addItem(item) {
        if (item && this.itemsArray.indexOf(item) < 0) {
          this.itemsArray.push(item);
        }
        this.newItem = '';
      }

      function isValid() {
        return this.name && this.itemsArray.length > 0;
      }

      function run() {
        try {
          List.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            removeItem: logWrapper(
              removeItem,
              runtimeConstant.isDebugModelsInternals
            ),
            addItem: logWrapper(
              addItem,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return List;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
